module.exports = __webpack_public_path__ + "img/product-list_m5.933f7992.png";